import React from "react"
import PropTypes from "prop-types"
import { Alert, AlertTriangleIcon } from "datastory-shared/ui"
import { useTranslation } from "datastory-shared/utils/i18n"

export const MissingDataNotification = ({ children }) => {
  const { t } = useTranslation()
  return (
    <Alert status="warning">
      <AlertTriangleIcon />
      {children ? children : t("og_c:missing-data")}
    </Alert>
  )
}

MissingDataNotification.propTypes = {
  children: PropTypes.node,
}
